module.exports = __webpack_public_path__ + "static/m_alpha_telegram_art-53d6d3cb23532e8753535c7408a8275c.png";